// extracted by mini-css-extract-plugin
export default {"block":"SmartPricing_block__y75Q9","p":"SmartPricing_p__8OdL9","btn":"SmartPricing_btn__RQwsJ"};